<template>
  <a-layout-content>
    <h2>JOYland-Auction赛事系统</h2>
        <a-form
          id="components-form-demo-normal-login"
          :form="loginform"
          class="login-form"
          @submit="loginSubmit"
        >
          <a-form-item>
            <a-input
              v-decorator="[
          'uname',
          { rules: [{ required: true,message: '请输入账号' }] }
        ]"
              placeholder="账号"
            >
              <a-icon slot="prefix" type="user" style="color: rgba(0,0,0,.25)"/>
            </a-input>
          </a-form-item>
          <a-form-item>
            <a-input
              v-decorator="[
          'password',
          { rules: [{ required: true, message: '请输入密码' }] }
        ]"
              type="password"
              placeholder="密码"
            >
              <a-icon slot="prefix" type="lock" style="color: rgba(0,0,0,.25)"/>
            </a-input>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" html-type="submit" class="login-form-button">登录</a-button>
          </a-form-item>
        </a-form>
        <h3>注册请联系赛事主办方或JOYland官方</h3>
  </a-layout-content>
</template>

<script>
export default {
  data () {
    return {
      uname: '',
      password: ''
    }
  },
  beforeCreate () {
    this.loginform = this.$form.createForm(this)
  },
  mounted () {
    this.$http
      .get('https://auction-api.joyland.top/user')
      .then(res => {
        if (!(res.data.code === 401)) {
          this.$router.push('/dashboard')
        }
      })
  },
  methods: {
    push (name) {
      this.$router.push('/' + name)
    },
    loginSubmit (e) {
      e.preventDefault()
      this.loginform.validateFields((err, values) => {
        if (!err) {
          const data = {
            uname: values.uname,
            password: this.$crypto.Encrypt(values.password)
          }
          this.$http
            .post('https://auction-api.joyland.top/login', data)
            .then(res => {
              if (res.data.code === 200) {
                this.$router.push('dashboard')
              } else {
                this.$message.warning(res.data.msg)
              }
            })
        }
      })
    }
  }
}
</script>

<style>
#components-form-demo-normal-login .login-form {
  max-width: 300px;
}
#components-form-demo-normal-login .login-form-button {
  width: 100%;
}
</style>
